import { Component, OnInit, ViewChild } from '@angular/core';
import {NgForm} from "@angular/forms";
import {AuthService} from "../service/auth.service";
import {AdminService} from "../service/admin.service";
import {LoadingController, ModalController, ToastController} from "@ionic/angular";

@Component({
  selector: 'app-pointofsale',
  templateUrl: './pointofsale.page.html',
  styleUrls: ['./pointofsale.page.scss'],
})
export class PointofsalePage implements OnInit {
  @ViewChild('form', {static: false}) ngForm: NgForm;
  loading: any;
  flagNaturalPerson: boolean;
  isFormBasicDataComplete = false;

  nitdigit: any;
  document: any;
  phone: any;
  firstName: any;
  secondName: any;
  firstLastName: any;
  documents: any;
  registeredBy: any;
  typeaccounts: any[];
  banks: any[];
  accountNumber: any;
  countries: any[];
  departments: any[];
  cities: any[];
  companyId: string;
  isFormAccountingInformation = false;
  identificationTypeRepId: any;
  cellPhone: any;
  taxRegimeId: number;
  select = false;
  taxRegimes: any;
  documentRep: any;
  phoneRep: any;
  cellPhoneRep: any;
  secondSurName: any;
  activities: any[] = [];
  filteredActivities: any[] = [];
  selectedActivity: any = null;
  disableSaveButton = true;

  constructor(private authService: AuthService,
    public toastController: ToastController,
    public modalController: ModalController,
    private adminService: AdminService,
    public loadingController: LoadingController) { }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });

    this.getCountries();
    this.getDepartmentsCountries();
    this.getCities();
    this.getBusinessActivityCiiu();
    this.getTypeIdentificationId();
    this.getFiscalResponsibility();
    this.getTypeaccountbank();
    this.getBanks();
    this.filteredActivities = [];


  }

  log() {
    console.log(this.flagNaturalPerson);
  }

  validateOnlyNumbers() {
    if (this.document) {
      this.document = this.document.replace(/\D/g, '');
      this.document = this.document.substring(0, 20);
    }
    if (this.phone) {
      this.phone = this.phone.replace(/\D/g, '');
      this.phone = this.phone.substring(0, 11);

    }
    this.disableSaveButton = !(/\d/.test(this.phone));    //condicion que valida el campo numero de cuenta y si la expresion regular se cumple devuelve false, lo que habilita el boton guardar
    if (this.nitdigit) {
      this.nitdigit = this.nitdigit.replace(/\D/g, '');
      this.nitdigit = this.nitdigit.substring(0, 2);

    }
    if (this.documentRep) {
      this.documentRep = this.documentRep.replace(/\D/g, '');
      this.documentRep = this.documentRep.substring(0,20);

    }
    if (this.phoneRep) {
      this.phoneRep = this.phoneRep.replace(/\D/g, '');
      this.phoneRep = this.phoneRep.substring(0, 11);

    }
    if (this.cellPhoneRep) {
      this.cellPhoneRep = this.cellPhoneRep.replace(/\D/g, '');
      this.cellPhoneRep = this.cellPhoneRep.substring(0, 12);

    }
    if (this.accountNumber) {
      this.accountNumber = this.accountNumber.replace(/\D/g, '');
      this.accountNumber = this.accountNumber.substring(0, 25);

    }
  }

  validateOnlyLetters() {
    if (this.firstName) {
      this.firstName = String(this.firstName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.secondName) {
      this.secondName = String(this.secondName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.firstLastName) {
      this.firstLastName = String(this.firstLastName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.secondSurName) {
      this.secondSurName = String(this.secondSurName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  async close(data: any) {
    await this.modalController.dismiss(data);
  }

  getTypeaccountbank() {
    this.loading.present();
    this.adminService.getTypeaccountbank().subscribe((res: any) => {
      this.typeaccounts = res;
      console.log(this.typeaccounts)
      this.loading.dismiss();
    });
  }

  getBanks() {
    this.loading.present();
    this.adminService.getBanks().subscribe((res: any) => {
      this.banks = res;
      console.log(this.banks)
      this.loading.dismiss();
    });
  }

  filterActivities(event: any) {
    const searchTerm = event.target.value.toLowerCase();
  
    if (searchTerm.length >= 2) {
      this.filteredActivities = this.activities.filter(activity =>
        activity.name.toLowerCase().includes(searchTerm) ||
        activity.classCiiu.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filteredActivities = [];
    }
  }

  selectActivity(activity: any) {
    this.selectedActivity = activity;
    this.filteredActivities = [];
    console.log('Esta es la actividad seleccionada:', this.selectedActivity);  
  }



  getCountries() {
    this.loading.present();
    this.adminService.getCountries().subscribe((res: any) => {
      this.countries = res;
      console.log(this.countries);
      this.loading.dismiss();
    });
  }

  getDepartmentsCountries(countryId?) {
    this.loading.present();
    this.adminService.getDepartments(countryId).subscribe((res: any) => {
      this.departments = res;
      this.loading.dismiss();
    });
  }

  getCities(departmentId?) {
    this.loading.present();
    this.adminService.getCities(departmentId).subscribe((res: any) => {
      this.cities = res;
      this.loading.dismiss();
    });
  }

  getBusinessActivityCiiu() {
    this.loading.present();
    this.adminService.getSupplierBusinessActivityCiiu().subscribe((res: any) => {
      this.activities = res;
      console.log(this.activities);
      this.loading.dismiss();
    });
  }

  getTypeIdentificationId() {
    this.loading.present();
    this.adminService.getTypeIdentificationId().subscribe((res: any) => {
      this.documents = res;
      console.log(this.documents);
      this.loading.dismiss();
    });
  }

  getFiscalResponsibility() {
    this.loading.present();
    this.adminService.getFiscalResponsibility().subscribe((res: any) => {
      this.taxRegimes = res;
      this.loading.dismiss();
    });

  }

  selectCheckbox2(checkboxIndex: number) {
    this.taxRegimeId = checkboxIndex;
    this.select = true;
    const checkboxCount = 5;
    for (let i = 0; i < checkboxCount; i++) {
      if (i !== checkboxIndex) {
        const checkboxElement = document.getElementsByClassName('checkbox3')[i] as HTMLIonCheckboxElement;
        checkboxElement.checked = false;
      }
    }
  }

  changeCountry(event: any) {
    if (event && event.detail && event.detail.value) {
      this.getDepartmentsCountries(event.detail.value);
    }
  }

  changeDepartment(event: any) {
    if (event && event.detail && event.detail.value) {
      this.getCities(event.detail.value);
    }
  }

  async basicDataPointOfSale(data) {
    data.isNaturalPerson = this.flagNaturalPerson === true ;
    this.authService.createPointOfSale(data).subscribe((response: any) => {
      this.loading.dismiss();
      this.presentToast('Datos básicos fueron guardados con éxito');
      this.isFormBasicDataComplete = true;
      this.close(true)

    }, error => {
      console.warn('Error al guardar datos basicos')
    }
    )
  }
}
